import { Observable } from 'rxjs';
import { FileDropTypes } from '../file-drop/file-drop.types';

export enum FileSelectionMode {
    DIALOG = 'DIALOG',
    INLINE = 'INLINE',
}

export enum TabType {
    SELECT = 'SELECT',
    UPLOAD = 'UPLOAD',
}

export interface TabConfig {
    id: string;
    label: string;
    type?: TabType;
    icon?: string;
    folderIcon?: string;
    folderIconSource?: string;
    badge?: string | number;
    disabled?: boolean;
    tooltip?: string;
    metadata?: Record<string, any>;
}

export interface DropdownOption {
    id: string;
    label: string;
    value?: any;
    groupKey?: string;
    groupLabel?: string;
    icon?: string;
    iconSource?: string;
    iconSize?: string;
    iconClass?: string;
    metadata?: Record<string, any>;
}

export interface CustomBackButton {
    label: string;
    icon: string;
    onClick: () => void;
}

export interface FileItem {
    id: string;
    name: string;
    size?: number;
    selected?: boolean;
    isFolder?: boolean;
    metadata?: any;
    [key: string]: any;
}

export interface SelectedFileGroup {
    dropdownId?: string;
    dropdownLabel?: string;
    tabId: string;
    tabLabel: string;
    files: FileItem[];
    groupKey?: string; // The key value used for grouping (e.g., "asdf" from metadata.file)
    groupLabel?: string; // Display label for the group key
}

export interface FileSelectionConfig {
    title?: string;
    tabs?: TabConfig[];
    maxTotalUploadedAttachments?: number; // Maximum number of files that can be selected across all tabs
    maxTotalUploadedFileSize?: number; // Maximum total file size allowed for all files across all tabs (in bytes)
    localUploadMaxFileSize?: number; // Maximum file size for individual locally uploaded files (defaults to 50MB)
    allowedFileTypes?: FileDropTypes[]; // Allowed file types for upload

    activeTabId?: string;
    dialogWidth?: string;
    dialogHeight?: string;
    submitButtonLabel?: string;
    cancelButtonLabel?: string;
    showSearch?: boolean;
    searchPlaceholder?: string;
    rowsPerPageOptions?: number[];
    defaultPageSize?: number;
    selectAllLabel?: string;
    emptyMessage?: string;

    selectedEmptyMessage?: string;
    selectedPanelTitle?: string;
    groupByKey?: string;
    showTotalAttachmentsCount?: boolean;
    initialSelectedFiles?: FileItem[];
    supportSubFolders?: boolean;
}

export interface FileSelectionChangeEvent {
    tabId: string;
    dropdownId: string | null;
    page: number;
    pageSize: number;
    searchQuery?: string;
    parentFolderId?: string | null;
}

export enum FileSelectionType {
    SELECTED_FILES = 'selectedFiles',
    UPLOADED_FILES = 'uploadedFiles',
}

export interface FileSelectionSubmitEvent {
    type: FileSelectionType;
    activeTabId?: string; // Tab id at submit time (reflects user's current tab, not just initial).
    selectedFiles?: SelectedFileGroup[];
    allSelectedFiles?: FileItem[];
    uploadedFiles?: File[];
}

export type FetchFunction = (event: FileSelectionChangeEvent) => Observable<{ items: FileItem[]; totalRecords: number }>;

